var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Spin',[_c('div',{staticStyle:{"width":"99vw","height":"99vh"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }